import DiscussionItem from "./DiscussionItem";

const DiscussionList = ({ threads }) => {
  if (threads.length === 0) {
    return <div className="text-sm text-gray-500">No comments yet</div>;
  }

  return (
    <div className="space-y-3">
      {threads.map((t) => (
        <DiscussionItem key={t.id} data={t} />
      ))}
    </div>
  );
};

export default DiscussionList;
